import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";
import { chipVariants, type ChipSize } from "@/components/ui/chip-variants";
import { cn } from "@/lib/utils";

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  size?: ChipSize;
}

const Chip = forwardRef<HTMLButtonElement, ChipProps>(
  ({ className, selected, size, type = "button", role, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        role={role}
        aria-pressed={role === "radio" ? undefined : (selected ?? false)}
        className={cn(chipVariants({ selected, size }), className)}
        {...props}
      />
    );
  },
);

Chip.displayName = "Chip";

export { Chip };
